import store from "../store";
import Dashboard from "../components/requests/Dashboard";
import pages from "../components/pages";

export default [
   {
      path: "/opt-out",
      name: "opt-out",
      component: Dashboard,
      beforeEnter: (to, from, next) => {
         store.dispatch("startSetActiveType", to.path);
         store.dispatch("optOut/startUnsetActive");
         if (to.query.status) {
            store.dispatch("optOut/startSetFilters", to.query);
         }
         return next();
      }
   },
   {
      path: "/opt-out/:id",
      name: "opt-out-request",
      component: pages.OptOut,
      beforeEnter: (to, from, next) => {
         store.dispatch("startSetActiveType", to.path);
         store.dispatch('optOut/startSetActive', to.params.id);
         return next();
      }
   },
   {
      path: "/request-to-know",
      name: "know",
      component: Dashboard,
      beforeEnter: (to, from, next) => {
         store.dispatch("startSetActiveType", to.path);
         store.dispatch("knowReq/startUnsetActive");
         if (to.query.status) {
            store.dispatch("knowReq/startSetFilters", to.query);
         }
         return next();
      }
   },
   {
      path: "/request-to-know/:id",
      name: "know-request",
      component: pages.Know,
      beforeEnter: (to, from, next) => {
         store.dispatch("startSetActiveType", to.path);
         store.dispatch('knowReq/startSetActive', to.params.id);
         return next();
      }
   },
   {
      path: "/request-to-delete",
      name: "delete",
      component: Dashboard,
      beforeEnter: (to, from, next) => {
         store.dispatch("startSetActiveType", to.path);
         store.dispatch("deleteReq/startUnsetActive");
         if (to.query.status) {
            store.dispatch("deleteReq/startSetFilters", to.query)
         }
         return next();
      }
   },
   {
      path: "/request-to-delete/:id",
      name: "delete-request",
      component: pages.Delete,
      beforeEnter: (to, from, next) => {
         store.dispatch("startSetActiveType", to.path);
         store.dispatch('deleteReq/startSetActive', to.params.id);
         return next();
      }
   }
]